module.exports = __webpack_public_path__ + "static/media/fw.72c15def.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Impact/img/fw.jpeg
// module id = 295
// module chunks = 0